import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/600.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';
import { CacheProvider } from '@emotion/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApiError } from './api/client';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { ToastProvider } from './components/Toast';
import { OrgThemeProvider } from './components/OrgThemeProvider';
import { initFavicon } from './lib/favicon';
import { getUiLanguage } from './lib/i18n';
import { ltrCache, rtlCache } from './theme';

initFavicon();
const language = getUiLanguage();
document.documentElement.lang = language;
document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CacheProvider value={language === 'ar' ? rtlCache : ltrCache}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <OrgThemeProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </OrgThemeProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </CacheProvider>
  </StrictMode>,
);
